import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  type: 'overallPerformance',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  // compareSelectedYearForYTD: '',
  // compareSelectedQuarterForYTD: '',
  overallPerformanceRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
  compareOverallPerformanceRangeTableOne: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
  overallPerformanceYTDRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
  compareOverallPerformanceRangeYTD: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },

}

const overallPerformanceSlice = createSlice({
  name: 'overallPerformance',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => {
      return { ...state, currentQuarter: action.payload }
    },
    setCurrentYear: (state, action) => {
      return { ...state, currentYear: action.payload }
    },
    setSelectedQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload }
    },
    setSelectedYear: (state, action) => {
      return { ...state, selectedYear: action.payload }
    },
    setCompareSelectedYear: (state, action) => {
      return { ...state, compareSelectedYear: action.payload}
    },
    setCompareSelectedQuarter: (state, action) => {
      return { ...state, compareSelectedQuarter: action.payload }
    },
    setOverallPerformanceRange: (state, action) => {
      return { ...state, overallPerformanceRange: action.payload }
    },
    setOverallPerformanceYTDRange: (state, action) => {
      return { ...state, overallPerformanceYTDRange: action.payload }
    },
    setCompareOverallPerformanceRangeForTableOne: (state, action) => {
      return { ...state, compareOverallPerformanceRangeTableOne: action.payload }
    },
    setCompareOverallPerformanceRangeYTD :(state, action) => {
      return { ...state, compareOverallPerformanceRangeYTD: action.payload }
    },
  }
})

export const overallPerformanceActions = overallPerformanceSlice.actions;

export default overallPerformanceSlice.reducer;
